import http from "./httpService";

const endPoint = "/api/v1/UnitsOfMeasure";

export async function getAllUnitsOfMeasure() {
    return await http.get(`${endPoint}`);
}

export default { getAllUnitsOfMeasure };


// WEBPACK FOOTER //
// ./src/services/UnitsOfMeasureService.js